export enum TermsEnum {
    GENERAL = 'GENERAL',
    RECEIVER_PAYS_DUTIES = 'RECEIVER_PAYS_DUTIES',
    RECEIVER_PAYS_DUTIES_CA_EXPORT = 'RECEIVER_PAYS_DUTIES_EXPORT',
    INTERNATIONAL = 'INTERNATIONAL'
}
